import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid-flex flex-column loading_main" }
const _hoisted_2 = { class: "p-2 h-60 d-flex justify-content-center align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-2 h-30 d-flex justify-content-center align-items-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-15 h-30",
    src: "/img/bg/defensil-logo.png"
  })
], -1)
const _hoisted_5 = { class: "p-2 h-10 d-flex justify-content-center align-items-center" }
const _hoisted_6 = { class: "progress w-50" }
const _hoisted_7 = ["aria-valuenow"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<ul class=\"steps\" id=\"steps\"><li id=\"step1\" class=\"step step--incomplete step--active\"><span class=\"step__icon diamond-l rotate\"></span></li><li id=\"step2\" class=\"step step--incomplete step--active\"><span class=\"step__icon flower-l rotateY\"></span></li><li id=\"step3\" class=\"step step--incomplete step--active\"><span class=\"step__icon heart-l rotate\"></span></li><li id=\"step4\" class=\"step step--incomplete step--active\"><span class=\"step__icon spade-l rotateY\"></span></li></ul>", 1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "w-35 h-50 mt-c-5",
        src: require('@/assets/images/bull.png')
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "progress-bar bg-gold",
          role: "progressbar",
          style: _normalizeStyle(_ctx.fullWidth),
          "aria-valuenow": _ctx.width,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, _hoisted_9, 12, _hoisted_7)
      ])
    ])
  ]))
}